import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { CourseGroup } from '../../types/content/courseGroup';
import type { SearchParams } from '../../types/search';

export async function searchCourseGroups(
  filter: object = {},
  params: SearchParams = {},
): Promise<CourseGroup[]> {
  return search<CourseGroup>('/course-group/search', filter, params);
}

export async function getCourseGroupById(id: string): Promise<CourseGroup> {
  return getById<CourseGroup>('/course-group', id);
}

export async function createCourseGroup(data: Partial<CourseGroup>): Promise<CourseGroup> {
  return post<CourseGroup>('/course-group', data);
}

export async function updateCourseGroup(id: string, data: CourseGroup): Promise<CourseGroup> {
  return put<CourseGroup>(`/course-group/${id}`, data);
}

export async function deleteCourseGroup(id: string): Promise<void> {
  return del<void>(`/course-group/${id}`);
}
